module.exports = __webpack_public_path__ + "static/media/part2.5347c7f6.jpg";